import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import { isDeviceForbiddenError } from '../../../lib/deviceAuthError'
import { InvalidCashierPinError } from './useVerifyCurrentCashierPin'

interface ChangeCashierPinInput {
  cashierId: string
  currentPin: string
  newPin: string
  confirmPin: string
}

interface ChangeCashierPinResult {
  success?: boolean
  error?: string
}

export class CashierPinMismatchError extends Error {
  constructor() {
    super('pin_mismatch')
  }
}

async function changeCashierPin(input: ChangeCashierPinInput): Promise<void> {
  const { data, error } = await supabase.functions.invoke<ChangeCashierPinResult>(
    'change-cashier-pin',
    { body: input },
  )

  if (data?.error === 'pin_mismatch') {
    throw new CashierPinMismatchError()
  }

  if (error || data?.error === 'internal_server_error') {
    const failure = error ?? new Error('change_cashier_pin_failed')
    if (!isDeviceForbiddenError(failure)) reportUnexpectedError(failure)
    throw failure
  }

  if (data?.success !== true) {
    throw new InvalidCashierPinError()
  }
}

export function useChangeCashierPin() {
  return useMutation({ mutationFn: changeCashierPin })
}
